import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SetupService {
  private api = environment.apiUrl;
  constructor(private http: HttpClient,  private router: Router, private route: ActivatedRoute) { }

  Upload(data: File, type): Observable<any> {
    const fd = new FormData();
    fd.append('file', data);
    return this.http.post(this.api + 'upload/' + type, fd);
  }

  getCode(mobile: string): Observable<any> {
    return this.http.get(this.api + 'bot/otp/' + mobile);
  }

  getDashboard(): Observable<any> {
    return this.http.get(this.api + 'paynow/dashboard/');
  }

  getSequences(): Observable<any> {
    return this.http.get(this.api + 'Sequence/GetAll');
  }

  getSequence(id: number): Observable<any> {
    return this.http.get(this.api + 'Sequence/Get/' + id);
  }

  postSequence(data): Observable<any> {
    return this.http.post(this.api + 'Sequence/Post', JSON.stringify(data));
  }

  putSequence(id: number, data): Observable<any> {
    return this.http.put(this.api + 'Sequence/Put/' + id, JSON.stringify(data));
  }

  delSequence(id: number): Observable<any> {
    return this.http.delete(this.api + 'Sequence/Delete/' + id);
  }

  getCountrys(): Observable<any> {
    return this.http.get(this.api + 'country');
  }

  getCountry(id: number): Observable<any> {
    return this.http.get(this.api + 'country/' + id);
  }

  postCountry(data): Observable<any> {
    return this.http.post(this.api + 'country', JSON.stringify(data));
  }

  putCountry(id: number, data): Observable<any> {
    return this.http.put(this.api + 'country/' + id, JSON.stringify(data));
  }

  delCountry(id: number): Observable<any> {
    return this.http.delete(this.api + 'country/' + id);
  }

  getRegions(): Observable<any> {
    return this.http.get(this.api + 'region');
  }

  getRegion(id: number): Observable<any> {
    return this.http.get(this.api + 'region/' + id);
  }

  postRegion(data): Observable<any> {
    return this.http.post(this.api + 'region', JSON.stringify(data));
  }

  putRegion(id: number, data): Observable<any> {
    return this.http.put(this.api + 'region/' + id, JSON.stringify(data));
  }

  delRegion(id: number): Observable<any> {
    return this.http.delete(this.api + 'region/' + id);
  }

  getLocations(): Observable<any> {
    return this.http.get(this.api + 'Region/GetAll');
  }

  getLocation(id: number): Observable<any> {
    return this.http.get(this.api + 'Region/Get/' + id);
  }

  postLocation(data): Observable<any> {
    return this.http.post(this.api + 'Region/Post', JSON.stringify(data));
  }

  putLocation(id: number, data): Observable<any> {
    return this.http.put(this.api + 'Region/Put/' + id, JSON.stringify(data));
  }

  delLocation(id: number): Observable<any> {
    return this.http.delete(this.api + 'Region/Delete/' + id);
  }

  getCompanys(): Observable<any> {
    return this.http.get(this.api + 'Merchant');
  }

  getCompany(merchantid: number): Observable<any> {
    return this.http.get(this.api + 'Merchant/' + merchantid);
  }

  postCompany(data): Observable<any> {
    return this.http.post(this.api + 'Merchant', JSON.stringify(data));
  }

  putCompany(merchantid: number, data): Observable<any> {
    return this.http.put(this.api + 'Merchant/' + merchantid, JSON.stringify(data));
  }

  delCompany(id: number): Observable<any> {
    return this.http.delete(this.api + 'Merchant/' + id);
  }

  uploadCompany(data): Observable<any> {
    return this.http.post(this.api + 'Merchant/batch', JSON.stringify(data));
  }

  getAllBranchs(): Observable<any> {
    return this.http.get(this.api + 'process');
  }

  getBranchs(): Observable<any> {
    return this.http.get(this.api + 'branch');
  }

  getBranch(id: number): Observable<any> {
    return this.http.get(this.api + 'branch/' + id);
  }

  getBranchbyCode(id: string): Observable<any> {
    return this.http.get(this.api + 'branch/code/' + id);
  }

  postBranch(data): Observable<any> {
    return this.http.post(this.api + 'branch', JSON.stringify(data));
  }

  uploadBranch(data): Observable<any> {
    return this.http.post(this.api + 'branch/batch', JSON.stringify(data));
  }

  putBranch(id: number, data): Observable<any> {
    return this.http.put(this.api + 'branch/' + id, JSON.stringify(data));
  }

  delBranch(id: number): Observable<any> {
    return this.http.delete(this.api + 'branch/' + id);
  }

  getAlerts(): Observable<any> {
    return this.http.get(this.api + 'alert');
  }

  getMainAlerts(): Observable<any> {
    return this.http.get(this.api + 'alert/main');
  }

  getAlertByType(type: string): Observable<any> {
    return this.http.get(this.api + 'Alert/Type/' + type);
  }

  getAlert(id: number): Observable<any> {
    return this.http.get(this.api + 'Alert/GetAsync/' + id);
  }

  postAlert(data): Observable<any> {
    return this.http.post(this.api + 'Alert/Post', JSON.stringify(data));
  }

  putAlert(id: number, data): Observable<any> {
    return this.http.put(this.api + 'Alert/Put/' + id, JSON.stringify(data));
  }

  delAlert(id: number): Observable<any> {
    return this.http.delete(this.api + 'Alert/DeleteAlert/' + id);
  }

  getSms(): Observable<any> {
    return this.http.get(this.api + 'Sms/GetAll');
  }

  getSmsByType(type: string): Observable<any> {
    return this.http.get(this.api + 'Sms/Type/' + type);
  }

  postSms(data): Observable<any> {
    return this.http.post(this.api + 'Sms/Post', JSON.stringify(data));
  }

  putSms(id: number, data): Observable<any> {
    return this.http.put(this.api + 'Sms/Put/' + id, JSON.stringify(data));
  }

  delSms(id: number): Observable<any> {
    return this.http.delete(this.api + 'Sms/Delete/' + id);
  }

  getAcctTypes(): Observable<any> {
    return this.http.get(this.api + 'accounttype');
  }

  getAcctType(id: number): Observable<any> {
    return this.http.get(this.api + 'accounttype/' + id);
  }

  postAcctType(data): Observable<any> {
    return this.http.post(this.api + 'accounttype', JSON.stringify(data));
  }

  putAcctType(id: number, data): Observable<any> {
    return this.http.put(this.api + 'accounttype/' + id, JSON.stringify(data));
  }

  delAcctType(id: number): Observable<any> {
    return this.http.delete(this.api + 'accounttype/' + id);
  }

  getSmsApis(): Observable<any> {
    return this.http.get(this.api + 'SmsApi/GetAll');
  }

  getSmsApi(id: number): Observable<any> {
    return this.http.get(this.api + 'SmsApi/Get/' + id);
  }

  postSmsApi(data): Observable<any> {
    return this.http.post(this.api + 'SmsApi/Post', JSON.stringify(data));
  }

  putSmsApi(id: number, data): Observable<any> {
    return this.http.put(this.api + 'SmsApi/Put/' + id, JSON.stringify(data));
  }

  delSmsApi(id: number): Observable<any> {
    return this.http.delete(this.api + 'SmsApi/Delete/' + id);
  }

  getSmslogs(): Observable<any> {
    return this.http.get(this.api + 'Sms/GetAll');
  }

  getSmslogsDistinct(): Observable<any> {
    return this.http.get(this.api + 'Sms/distinct');
  }

  getSmslog(id: number): Observable<any> {
    return this.http.get(this.api + 'Sms/Get/' + id);
  }

  postSmslog(data): Observable<any> {
    return this.http.post(this.api + 'Sms/Post', JSON.stringify(data));
  }

  putSmslog(id: number, data): Observable<any> {
    return this.http.put(this.api + 'Sms/Post' + id, JSON.stringify(data));
  }

  delSmslog(id: number): Observable<any> {
    return this.http.delete(this.api + 'Sms/Delete/' + id);
  }

  getUsers(): Observable<any> {
    return this.http.get(this.api + 'auth/users');
  }

  getUser(id: number): Observable<any> {
    return this.http.get(this.api + 'auth/user/' + id);
  }

  resetUser(email): Observable<any> {
    return this.http.get(this.api + 'auth/reset/' + email);
  }

  postUser(data): Observable<any> {
    return this.http.post(this.api + 'auth/user', JSON.stringify(data));
  }

  putUser(id: string, data): Observable<any> {
    return this.http.put(this.api + 'auth/user/' + id, JSON.stringify(data));
  }

  delUser(id: number): Observable<any> {
    return this.http.delete(this.api + 'auth/' + id);
  }

  getLicences(): Observable<any> {
    return this.http.get(this.api + 'licence');
  }

  getLicence(id: number): Observable<any> {
    return this.http.get(this.api + 'licence/' + id);
  }

  postLicence(data): Observable<any> {
    return this.http.post(this.api + 'licence', JSON.stringify(data));
  }

  putLicence(id: number, data): Observable<any> {
    return this.http.put(this.api + 'licence/' + id, JSON.stringify(data));
  }

  delLicence(id: number): Observable<any> {
    return this.http.delete(this.api + 'licence/' + id);
  }

  updateUrl(page=1,limit=10,search='') {
    const params = { page: page, limit: limit, search: search };
    this.router.navigate([],{
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: 'merge',
      skipLocationChange: false
    }).finally(()=> {

    });
  }


}
